import script from "./inactive_page.vue?vue&type=script&setup=true&lang=js"
export * from "./inactive_page.vue?vue&type=script&setup=true&lang=js"

import "./inactive_page.vue?vue&type=style&index=0&id=65490a51&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65490a51"]])

export default __exports__